import React, { useEffect, useRef } from "react";
import Sec1 from "./sec1-components/sec1";
import Sec2 from "./sec2-components/sec2";
import Sec3 from "./sec3-components/sec3";
import Sec4 from "./sec4-components/sec4";
import Sec5 from "./sec5-components/sec5";
import Sec6 from "./sec6-components/sec6";
import Sec7 from "./sec7-components/sec7";
import Sec8 from "./sec8-components/sec8";
import Sec9 from "./sec9-components/sec9";
import Sec10 from "./sec10-components/sec10";
import Sec11 from "./sec11-components/sec11";
import Sec12 from "./sec12-components/sec12";
import Sec13 from "./sec13-components/sec13";
import Sec14 from "./sec14-components/sec14";
import Sec15 from "./sec15-components/sec15";
import Sec16 from "./sec16-components/sec16";
import Sec17 from "./sec17-components/sec17";
import Sec18 from "./sec18-components/sec18";
import Sec19 from "./sec19-components/sec19";

const BSG: React.FC = () => {
  const topRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const sec19 = document.getElementById("sec19");
      if (sec19) {
        const rect = sec19.getBoundingClientRect();
        if (rect.top <= window.innerHeight) {
          // Adding a slight delay to ensure the DOM has updated
          setTimeout(() => {
            topRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 50);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="bsg-v">
      <div id="sec1" ref={topRef}>
        <Sec1 />
      </div>
      <div id="sec2">
        <Sec2 />
      </div>
      <div id="sec3">
        <Sec3 />
      </div>
      <div id="sec4">
        <Sec4 />
      </div>
      <div id="sec5">
        <Sec5 />
      </div>
      <div id="sec6">
        <Sec6 />
      </div>
      <div id="sec7">
        <Sec7 />
      </div>
      <div id="sec8">
        <Sec8 />
      </div>
      <div id="sec9">
        <Sec9 />
      </div>
      <div id="sec10">
        <Sec10 />
      </div>
      <div id="sec11">
        <Sec11 />
      </div>
      <div id="sec12">
        <Sec12 />
      </div>
      <div id="sec13">
        <Sec13 />
      </div>
      <div id="sec14">
        <Sec14 />
      </div>
      <div id="sec15">
        <Sec15 />
      </div>
      <div id="sec16">
        <Sec16 />
      </div>
      <div id="sec17">
        <Sec17 />
      </div>
      <div id="sec18">
        <Sec18 />
      </div>
      <div id="sec19">
        <Sec19 />
      </div>
    </div>
  );
};

export default BSG;